import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';

// `zIndex`: a Tailwind z-index class, for a dialog that opens over a higher layer (e.g. a slide-over at z-40).
export default function CustomDialog({
  children,
  isOpen,
  headerText,
  closeModal,
  maxWidth = 'max-w-4xl',
  zIndex = 'z-10',
}) {
  // function openModal() {
  //   setIsOpen(true);
  // }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as='div' className={`relative ${zIndex}`} onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-slate-900/50' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-2 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className={`w-full ${maxWidth} transform rounded-2xl bg-white p-6 text-left align-middle shadow-2xl ring-1 ring-slate-900/5 transition-all`}>
                  <Dialog.Title
                    as='h3'
                    className='text-lg font-semibold leading-6 text-slate-900'
                  >
                    {headerText}
                  </Dialog.Title>
                  <div className='mt-2'>{children}</div>

                  {/* <div className='mt-4 text-right'>
                    <button
                      type='button'
                      className='inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2'
                      onClick={closeModal}
                    >
                      Got it, thanks!
                    </button>
                  </div> */}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
